import { GLOBAL_OBJ } from '@sentry/utils';

export const WINDOW = GLOBAL_OBJ as typeof GLOBAL_OBJ & Window;



// WEBPACK FOOTER //
// ../../../../src/browser/types.ts